import * as yup from 'yup'

const schema = yup.object().shape({
  organizationId: yup.number().required(),
})

export default schema
